<template>
  <!--
      	作者：kmdshop
      	时间：2020-06-01
      	描述：插件中心-分销-提现申请
      -->
  <div class="user">
    <div class="common-seach-wrap">
      <el-form size="small" :inline="true" :model="formInline" class="demo-form-inline">
        <el-form-item label="审核状态">
          <el-select v-model="formInline.apply_status" placeholder="请选择状态">
            <el-option label="全部" value="-1"></el-option>
            <el-option label="待审核" value="10"></el-option>
            <el-option label="审核通过" value="20"></el-option>
            <el-option label="已打款" value="40"></el-option>
            <el-option label="驳回" value="30"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="等级">
          <el-select v-model="formInline.grade_id" placeholder="请选择等级">
            <el-option label="全部" :value="-1"></el-option>
            <el-option v-for="(item,index) in grade" :key="index" :label="item.name" :value="item.grade_id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="所属团队">
          <el-select v-model="formInline.user_team_id" placeholder="请选择所属团队">
            <el-option label="全部" :value="-1"></el-option>
            <el-option v-for="(item,index) in team" :key="index" :label="item.name" :value="item.user_team_id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="提现方式">
          <el-select v-model="formInline.pay_type" placeholder="请选择提现方式">
            <el-option label="全部" value="-1"></el-option>
            <el-option label="微信" value="10"></el-option>
            <el-option label="支付宝" value="20"></el-option>
            <el-option label="银行卡" value="30"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="申请时间">
        <el-date-picker
          size="small"
          v-model="formInline.apply_time"
          type="daterange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          format="yyyy-MM-dd"
          value-format="yyyy-MM-dd"
        >
        </el-date-picker>
      </el-form-item>

      <el-form-item label="审核时间">
        <el-date-picker
          size="small"
          v-model="formInline.audit_time"
          type="daterange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          format="yyyy-MM-dd"
          value-format="yyyy-MM-dd"
        >
        </el-date-picker>
      </el-form-item>

      
        <el-form-item label="用户id">
          <el-input v-model="formInline.user_id" placeholder="请输入用户ID"></el-input>
        </el-form-item>
        <el-form-item label=""><el-input v-model="formInline.search" placeholder="请输入昵称/姓名/手机号"></el-input></el-form-item>
        <el-form-item><el-button type="primary" @click="getData(true)">查询</el-button></el-form-item>
        <el-form-item><el-button  type="button" @click="reast">重置</el-button></el-form-item>
        <!-- <el-form-item><el-button type="primary" @click="statics">金额统计</el-button></el-form-item> -->
      </el-form>
    </div>

    <!--内容-->
    <div class="product-content">
      <!-- <div style="float: right;line-height: 40px;">
        提现金额：{{ statics_data.money}}元 实际获得金额：{{ statics_data.true_money}}元 提现手续费：{{ statics_data.cash_fee}}元
      </div> -->
      <div style="clear: both;"></div>
      <div class="table-wrap">
        <el-table :data="tableData" border style="width: 100%" v-loading="loading">
          <el-table-column prop="user_id" label="用户ID" width="60"></el-table-column>
          <el-table-column prop="nickName" label="微信头像" width="70">
            <template slot-scope="scope">
              <img class="radius" v-img-url="scope.row.avatarUrl" width="30" height="30" />
            </template>
          </el-table-column>
          <el-table-column prop="nickName" label="客户信息" width="150">
            <template slot-scope="scope">
              <div style="height: 80px;width:210px; overflow-x:auto;">
                <div> 昵称：{{ scope.row.nickName }}</div>  
                <div> 手机号：{{ scope.row.mobile }}</div>  
                <div v-if="scope.row.grade && scope.row.grade.name"> 等级：{{scope.row.grade.name?scope.row.grade.name: scope.row.grade_name }}</div>  
                <div v-if="scope.row.userTeam && scope.row.userTeam.name">  团队：{{scope.row.userTeam.name?scope.row.userTeam.name: scope.row.user_team_name }}</div>  
                
               
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="apply_status.text" label="审核状态"></el-table-column>

         
          <el-table-column prop="money" label="提现金额">
            <template slot-scope="scope">
              <span class="orange">{{ scope.row.true_money }}</span>
            </template>
          </el-table-column>
           <el-table-column prop="true_money" label="实际获得金额">
            <template slot-scope="scope">
              <span class="orange">{{ scope.row.money }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="cash_fee" label="提现手续费">
            <template slot-scope="scope">
              <span class="orange">{{ scope.row.cash_fee }}</span>
            </template>
          </el-table-column>

          <el-table-column prop="pay_type.text" label="提现方式"></el-table-column>
          <el-table-column prop="pay_type" label="提现信息	" width="230">
            <template slot-scope="scope">
              <div style="height: 80px;width:210px; overflow-x:auto;">
                    <div v-if="scope.row.pay_type.value == 20">
                    <p>
                      姓名：<span>{{ scope.row.alipay_name }}</span>
                    </p>
                    <p>
                    支付宝账号：<span>{{ scope.row.alipay_account }}</span>
                    </p>
                    <p v-if="scope.row.card">
                    身份证号：<span>{{ scope.row.card }}</span>
                    </p>
                  </div>
                  <div v-else-if="scope.row.pay_type.value == 30">
                    <p>
                      姓名：<span>{{ scope.row.bank_name }}</span>
                    </p>
                    <p>
                      银行信息：<span>{{ scope.row.bank_account }}</span>
                    </p>
                    <p>
                      银行卡号：<span>{{ scope.row.bank_card }}</span>
                    </p>
                    <p v-if="scope.row.card">
                    身份证号：<span>{{ scope.row.card }}</span>
                    </p>
                  </div>
                  <div v-else>
                    <p><span>--</span></p>
                  </div>
              
              </div>
              
            </template>
          </el-table-column>
        
          <el-table-column prop="create_time" label="申请时间" width="135"></el-table-column>
          <el-table-column prop="audit_time" label="审核时间" width="135"></el-table-column>
          <el-table-column fixed="right" label="操作" width="180">
            <template slot-scope="scope">
              <!-- <el-button @click="staticsClick(scope.row)" type="text" size="small">金额统计</el-button> -->
              <div><el-button @click="orderClick(scope.row)" type="text" size="small" >分销订单</el-button></div>
              
              <div v-if="scope.row.apply_status.value == 10 || scope.row.apply_status.value == 20">
                <el-button @click="editClick(scope.row)" type="text" size="small" v-auth="'/plus/agent/cash/submit'">审核</el-button>
                <template v-if="scope.row.apply_status.value == 20">
                  <el-button @click="makeMoney(scope.row)" type="text" size="small" v-auth="'/plus/agent/cash/money'">确认打款</el-button>
                </template>
                <template v-if="scope.row.apply_status.value == 20 && scope.row.pay_type.value == 10">
                  <el-button @click="WxPay(scope.row.id)" type="text" size="small" v-auth="'/plus/agent/cash/money'">微信付款</el-button>
                </template>
              </div>
              <div v-if="scope.row.apply_status.value == 30">
                <el-button @click="editClick(scope.row)" type="text" size="small">查看详情</el-button>
               </div>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <!--分页-->
      <div class="pagination">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          background
          :current-page="curPage"
          :page-size="pageSize"
          :page-sizes="[5, 10, 20, 30, 40, 50, 60, 70, 80, 90, 100]"
          layout="total, prev, sizes, pager, next, jumper"
          :total="totalDataNumber"
        ></el-pagination>
      </div>
    </div>
    <Edit v-if="open_edit" :open_edit="open_edit" :form="userModel" @closeDialog="closeDialogFunc($event, 'edit')"></Edit>
    <Statics v-if="statics_flag" :user_id="user_id" :open_edit="statics_flag" @closeDialog="closeDialogSFunc($event, 'edit')"></Statics>
  </div>
</template>

<script>
import PlusApi from '@/api/plus.js';
import Edit from './dialog/Edit.vue';
import Statics from './dialog/Statics.vue';
export default {
  components: {
    /*编辑组件*/
    Edit,
    Statics
  },
  data() {
    return {
      /*是否加载完成*/
      loading: true,
      /*列表数据*/
      tableData: [],
      /*一页多少条*/
      pageSize: 10,
      /*一共多少条数据*/
      totalDataNumber: 0,
      /*当前是第几页*/
      curPage: 1,
      formInline: {
        search: '',
        /*用户ID*/
        user_id: '',
        user_team_id:-1,
        grade_id:-1,
        apply_time:"",
        audit_time:"",
      },
      /*是否打开编辑弹窗*/
      open_edit: false,
      /*当前编辑的对象*/
      userModel: {},
      team:[],
      grade:[],
      statics_flag:false,
      user_id:"",
      statics_data:{}
    };
  },
  props: {},
  watch:{

    $route(to, from) {
      if (to.query.user_id != null) {
        this.formInline.user_id = to.query.user_id;
      }else{
        this.formInline.user_id ='';
      }
      this.curPage = 1;
      this.getData();
    }

  },
  created() {
    if (this.$route.query.user_id != null) {
      this.formInline.user_id = this.$route.query.user_id;
    }
    /*获取列表*/
    this.getData();
    this.getUserTeam();
  },
  methods: {
    orderClick(item){
      this.$router.push({
        path: '/plus/agent/index?type=order',
        query: {
          user_id: item.user_id
        }
      });
    },
    statics(){
      this.statics_flag = true;
    },
    staticsClick(item){
      this.statics_flag = true;
      console.log(item)
      this.user_id = item.user_id
    },
    reast(){
      this.formInline = {
        search: '',
        /*用户ID*/
        user_id: '',
        user_team_id:-1,
        grade_id:-1,
        apply_time:"",
      }
      this.getData();
    },
    /*获取数据*/
    getData(submit = false) {
      let self = this;
      self.loading = true;
      let Params = self.formInline;
      Params.page = submit ? 1 : self.curPage;
      Params.list_rows = self.pageSize
      PlusApi.cash(Params, true)
        .then(data => {
          self.loading = false;
          self.tableData = data.data.list.data;
          self.totalDataNumber = data.data.list.total;
          self.statics_data = data.data.statics;
        })
        .catch(error => {
          self.loading = false;
        });
    },
    getUserTeam(){
      let self = this;
      self.loading = true;
      PlusApi.getUserTeam({}, true)
        .then(data => {
          self.team  = data.data.team;
          self.grade = data.data.grade

        })
        .catch(error => {
          self.loading = false;
        });
    },

    /*每页多少条*/
    handleSizeChange(val) {
      this.curPage = 1;
      this.pageSize = val;
      this.getData();
    },

    /*选择第几页*/
    handleCurrentChange(val) {
      let self = this;
      self.curPage = val;
      self.getData();
    },

    /*打开弹出层编辑*/
    editClick(item) {
      this.userModel = item;
      this.open_edit = true;
    },

    /*关闭弹窗*/
    closeDialogFunc(e, f) {
      if (f == 'add') {
        this.open_add = e.openDialog;
        if (e.type == 'success') {
          this.getData();
        }
      }
      if (f == 'edit') {
        this.open_edit = e.openDialog;
        if (e.type == 'success') {
          this.getData();
        }
      }
    },
    closeDialogSFunc(){
      this.statics_flag = false;
      this.user_id = "";
    },

    /*确认打款*/
    makeMoney(e) {
      let self = this;
      self
        .$confirm('确认要打款吗?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
        .then(() => {
          self.loading = true;
          PlusApi.money(
            {
              id: e.id
            },
            true
          )
            .then(data => {
              self.loading = false;
              if (data.code == 1) {
                self.$message({
                  message: '恭喜你，操作成功',
                  type: 'success'
                });
                this.getData();
              } else {
                self.loading = false;
              }
            })
            .catch(error => {
              self.loading = false;
            });
        })
        .catch(() => {});
    },

    /*微信打款*/
    WxPay(e) {
      let self = this;
      self
        .$confirm('该操作 将使用微信支付企业付款到零钱功能，确定打款吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
        .then(() => {
          self.loading = true;
          PlusApi.WxPay(
            {
              id: e
            },
            true
          )
            .then(data => {
              self.loading = false;
              if (data.code == 1) {
                self.$message({
                  message: '恭喜你，操作成功',
                  type: 'success'
                });
                this.getData();
              } else {
                self.loading = false;
              }
            })
            .catch(error => {
              self.loading = false;
            });
        })
        .catch(() => {});
    }
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/plus/agent/cash/Cash.vue